// Version : 0.0.2
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'REMOVE UNUSED LINES'
// Modified Date : 06/12/2025
import GoldLoanDisbursementTypes from './gold-loan-disbursement.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// FETCH GOLD LOAN INDEX BASED GROUP
	fetchGoldLoanDisbursementResponse: null,
	fetchGoldLoanDisbursementArr: [],
	// FETCH GOLD LOAN INDEX BASED GROUP LIST
	fetchGoldLoanIndexDisbursementListResponse: null,
	fetchGoldLoanIndexDisbursementListArr: [],
	// UPDATE GOLD LOAN DISBURSEMENT
	updateGoldLoanDisbursementResponse: null,
};

const goldLoanDisbursementReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET ALL LOAN INDEX BASED GROUP START *********************** */
		case GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_SUCCESS:
			return {
				...state,
				fetchGoldLoanDisbursementResponse: action.payload,
				fetchGoldLoanDisbursementArr: docodeHexResponse(
					action.payload,
					'FetchGoldLoanIndexDetailKey',
				),
			};

		case GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_FAILURE:
			return { ...state, fetchGoldLoanDisbursementResponse: action.payload };

		case GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_RESPONSE_CHANGED:
			return { ...state, fetchGoldLoanDisbursementResponse: null };
		/** ***************** GET ALL LOAN INDEX BASED GROUP END *********************** */

		/** ***************** GET ALL LOAN INDEX BASED ON GROUP LIST START *********************** */
		case GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_SUCCESS:
			return {
				...state,
				fetchGoldLoanIndexDisbursementListResponse: action.payload,
				fetchGoldLoanIndexDisbursementListArr: docodeHexResponse(
					action.payload,
					'GoldLoanIndexListGroupKey',
				),
			};

		case GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_FAILURE:
			return { ...state, fetchGoldLoanIndexDisbursementListResponse: action.payload };

		case GoldLoanDisbursementTypes.GOLD_LOAN_INDEX_DISBURSEMENT_LIST_RESPONSE_CHANGED:
			return { ...state, fetchGoldLoanIndexDisbursementListResponse: null };
		/** ***************** GET ALL LOAN INDEX BASED ON GROUP LIST END *********************** */

		/** ***************** UPDATE GOLD LOAN DISBURSEMENT START *********************** */
		case GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_SUCCESS:
			return {
				...state,
				updateGoldLoanDisbursementResponse: action.payload,
			};

		case GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_FAILURE:
			return { ...state, updateGoldLoanDisbursementResponse: action.payload };

		case GoldLoanDisbursementTypes.UPDATE_GOLD_LOAN_DISBURSEMENT_RESPONSE_CHANGED:
			return { ...state, updateGoldLoanDisbursementResponse: null };
		/** ***************** UPDATE GOLD LOAN DISBURSEMENT END *********************** */
		default:
			return state;
	}
};
export default goldLoanDisbursementReducer;
